import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from 'react-phone-number-input'
import { getWebsiteForm, submitWebsiteForm, submitContactForm } from '../../api/api';
import { Row, Col, Form, Select, Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons'
import { isUndefined } from "lodash";
import './contactPage.style.scss';
import { renderInputField, renderDateField, renderEmailField, renderTextAreaField, renderPhoneField } from '../../components/formFields';

const ContactPage = () => {
  const navigate = useNavigate();

  // Prod Form
  const formId = "2546454c-2cc9-424d-bad3-655323bb6eda";
  // Dev Form
  // const formId = "df9c96c1-c340-44a0-8a99-7e7a5b70d37e";

  const fieldTypes = {
    SELECT: "select",
    TEXT: "text",
    EMAIL: "email",
    PHONE: "phone",
    DATE: "date",
    TEXTAREA: "textarea"
  }

  const fieldKeys = {
    EVENT_TYPE_ID: "event_type_id",
    CONTACT_TYPE_ID: "contact_type_id",
    REFERRAL_SOURCE_ID: "referral_source_id",
    EVENT_TYPE_NAME: "event_type_name",
    CONTACT_TYPE_NAME: "contact_type_name",
    REFERRAL_SOURCE_NAME: "referral_source_name",
    REFERRAL_SOURCE_OTHER: "referral_source_other",
  }

  const fieldOptionLabels = {
    WEDDING: "Wedding",
    OTHER: "Other"
  }

  const [isLoading, setLoading] = useState(false);
  const [eventTypes, setEventTypes] = useState([]);
  const [contactTypes, setContactTypes] = useState([]);
  const [referralSources, setReferralSources] = useState([]);
  const [formFields, setFormFields] = useState([]);
  const [showContactType, setShowContactType] = useState(false);
  const [showReferralOther, setShowReferralOther] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0)

    // getWebsiteForm(formId).then(response => {
    //   if (response.data.form_fields) {
    //     setEventTypes(response.data.event_types);
    //     setContactTypes(response.data.contact_types);
    //     setReferralSources(response.data.referral_sources);
    //     setFormFields(response.data.form_fields);
    //   }
    //   setLoading(false);
    // }).catch(error => displayError());
  }, [])

  const onSubmit = async (values) => {
    try {
      const body = {
        ...values,
        // 'event_type_name': values["event_type_id"].label,
        // 'event_type_id': values["event_type_id"].key,
        // 'contact_type_name': isUndefined(values["contact_type_id"]) ? "" : values["contact_type_id"].label,
        // 'contact_type_id': isUndefined(values["contact_type_id"]) ? "" : values["contact_type_id"].key,
        // 'referral_source_name': values["referral_source_id"].label,
        // 'referral_source_id': values["referral_source_id"].key,
        'event_date': values['event_date'].format('YYYY-MM-DD'),
        'event_date_long': values['event_date'].format('MMMM DD, YYYY (dddd)'),
        'phone': getParsedPhoneNumber(values['phone']),
        'phone_formatted': formatPhoneNumber(values['phone']) 
      }

      console.log(body)

      // await submitContactForm(body)
      // displaySuccess()
      // submitWebsiteForm(formId, body).then(response => {
      //   displaySuccess()
      // })
    } catch (error) {
      console.log(error)
    }
  }

  const getParsedPhoneNumber = (value) => {
    return value ? value.replace("+1","") : "";
  }

  const displaySuccess = () => {
    Modal.success({
      content: 'Thank you!',
      onOk: afterSuccess
    });
  }

  const displayError = () => {
    setLoading(false)
    Modal.error({
      content: 'Please try again later.',
      onOk: () => navigate("/")
    });
  }

  const afterSuccess = () => {
    navigate("/");
  }

  const widthStyle = (value) => {
    return {
      width: '100%',
      maxWidth: value
    }
  }

  const handleSelectChange = (selectedObject, field) => {
    // Hide Contact Type select box if event type is Wedding
    if (field.id === fieldKeys.EVENT_TYPE_ID) {
      if (selectedObject.label === fieldOptionLabels.WEDDING) {
        setShowContactType(true);
      } else {
        setShowContactType(false);
      }
    } else if (field.id === fieldKeys.REFERRAL_SOURCE_ID) {
      if (selectedObject.label === fieldOptionLabels.OTHER) {
        setShowReferralOther(true);
      } else {
        setShowReferralOther(false);
      }
    }
  }

  const renderFormLabel = (name) => {
    return <div className="form-label">{name}</div>;
  }

  const renderSelectField = (field, options) => {
    return (
      <>
        {renderFormLabel(field.label)}
        <Form.Item
          name={field.id}
          style={widthStyle(field.width)}
          rules={[{ required: field.required, message: `${field.label} is required!` }]}
        >
          <Select labelInValue size="large" onChange={(x) => handleSelectChange(x, field)}>
            { renderSelectOptions(field) }
          </Select>
        </Form.Item>
      </>
    )
  }

  const renderSelectOptions = (field) => {
    var options = [], value = "";

    if (field.id === fieldKeys.EVENT_TYPE_ID) {
      // Event Types
      options = eventTypes;
      value = fieldKeys.EVENT_TYPE_NAME;
    } else if (field.id === fieldKeys.CONTACT_TYPE_ID) {
      // Contact Types
      options = contactTypes;
      value = fieldKeys.CONTACT_TYPE_NAME;
    } else if (field.id === fieldKeys.REFERRAL_SOURCE_ID) {
      // Referral Sources
      options = referralSources;
      value = fieldKeys.REFERRAL_SOURCE_NAME;
    }

    var items = [];
    options.forEach(type => {
      items.push(<Select.Option value={type[field.id]} key={type[field.id]}>{type[value]}</Select.Option>);
    });

    return items;
  }

  const renderFormField = (field) => {
    if (field.type === fieldTypes.SELECT) {
      if (field.id !== fieldKeys.CONTACT_TYPE_ID || (field.id === fieldKeys.CONTACT_TYPE_ID && showContactType)) {
        return renderSelectField(field);
      }
    } else if (field.type === fieldTypes.TEXT) {
      if (field.id !== fieldKeys.REFERRAL_SOURCE_OTHER || (field.id === fieldKeys.REFERRAL_SOURCE_OTHER && showReferralOther)) {
        return renderInputField(field.label, field.id, field.width, field.required);
      }
    } else if (field.type === fieldTypes.DATE) {
      return renderDateField(field.label, field.id, field.width, field.required);
    } else if (field.type === fieldTypes.PHONE) {
      return renderPhoneField(field.label, field.id, field.width, field.required);
    } else if (field.type === fieldTypes.EMAIL) {
      return renderEmailField(field.label, field.id, field.width, field.required);
    } else if (field.type === fieldTypes.TEXTAREA) {
      return renderTextAreaField(field.label, field.id, field.width, field.required);
    } 
    return null;
  }

  const renderFormFields = () => {
    return (
      <>
        { renderInputField("First Name", "first_name", "50%", true) }
        { renderInputField("Last Name", "last_name", "50%", true) }
        { renderEmailField("Email", "email", "100%", true) }
        { renderPhoneField("Phone", "phone", "20%", true) }
        { renderDateField("Event Date", "event_date", "30%", true) }
        { renderInputField("Venue", "venue", "100%", true) }
        { renderTextAreaField("Tell us about your event!", "message", "100%", true) }
        { renderInputField("Who can we thank for your referral?", "referral", "100%", true) }
      </>
    )

    // return formFields.map((x, i) => {
    //   return (
    //     <div key={i}>
    //       {renderFormField(x)}
    //     </div>
    //   )
    // })
  }

  const renderContent = () => {
    if (isLoading) {
      return <div className="loading-spinner-container"><LoadingOutlined style={{ fontSize: 40 }}/></div>
    } else {
      return (
        <>
          <div className="page-title-section">
            <div className="page-title-1">
              Need a quote?
            </div>
            <div className="page-title-2">
              Contact us
            </div>
          </div>
          <Row justify="center">
            <Col xs={22} md={18} lg={12} xl={10}>
              <div className="contact-box">
                <Form  layout="vertical" name="contact" onFinish={onSubmit}>
                  { renderFormFields() }
                  <button className="content-section-button" type="submit">Submit</button>
                </Form>
              </div>
            </Col>
          </Row>
        </>
      )
    }
  }

  return (
    <div className="contact-page white-bg">
      { renderContent() }
    </div>
  );
}

ContactPage.propTypes = {};

export default ContactPage;
